/**
 * CONFIGURACION PAGE — Configuración del Sistema
 */

import { useTranslation } from "react-i18next";
import { Settings } from "lucide-react";

export default function ConfiguracionPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <Settings className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
        <div>
          <h1 className="text-lg sm:text-2xl font-bold">{t("configuracion.title")}</h1>
          <p className="text-xs sm:text-sm text-muted-foreground">
            {t("configuracion.description")}
          </p>
        </div>
      </div>

      {/* Placeholder — configuración general del sistema */}
      <div className="rounded-lg border border-dashed p-8 text-center text-muted-foreground">
        <Settings className="mx-auto h-12 w-12 mb-4 opacity-50" />
        <p className="text-sm">{t("configuracion.placeholder")}</p>
      </div>
    </div>
  );
}
